import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'

const addPostComment = async ({ comment, postId }) => {
	const uid = getCurrentUid()
	if (uid) {
		const myComment = {
			...comment,
			createdTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
			modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
			postId
		}

		try {
			const commentDocRef = firestore.collection('posts').doc(postId).collection('comments').doc()
			myComment.commentId = commentDocRef.id
			await commentDocRef.set(myComment)
			return { comment: myComment }
		} catch (exception) {
			throw errorOfType(errorTypes.UNKNOWNERROR, postId, exception)
		}
	}
	throw errorOfType(errorTypes.KEYNOTSPECIFIED, `No User ID for posting comment for postId: ${postId}`)
}

export default addPostComment



// WEBPACK FOOTER //
// ./src/dataservices/addPostComment.js